import { Component, OnInit } from '@angular/core';
import { ChargeService } from '../../../../core/services/charge.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../../core/services/utils.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from '../../../../core/services/helper.service';
import { PaymentService } from '../../../../core/services/payment.service';

@Component({
  selector: 'app-payment-static-success',
  templateUrl: './payment-static-success.component.html',
  styleUrls: ['./payment-static-success.component.scss']
})
export class PaymentStaticSuccessComponent implements OnInit {
  urlParams: any;
  charge: any;
  callbackEndpoint: string;
  isRedirectShown = false;

  constructor(
    private utilsService: UtilsService,
    private chargeService: ChargeService,
    public helperService: HelperService,
    public sanitizing: DomSanitizer,
    public paymentService: PaymentService
  ) {
    // hide content loader
    this.utilsService.hideContentLoader();

    // hide terminate button
    this.utilsService.hideTerminatePayment();

    // set url params
    this.urlParams = this.utilsService.urlParams$$.value;

    // set charge details
    this.charge = this.chargeService.charge$$.value;

    this.callbackEndpoint = '';
  }

  ngOnInit() {
    if (this.paymentService.paymentInProgress$$.value?.claim_processed) {
      return;
    }

    // set callback endpoint
    this.callbackEndpoint = this.utilsService.modifyUrl(
      this.charge.callback_endpoint,
      `payment_method=${this.urlParams['payment_method']}&payment_status=${this.urlParams['payment_status']}&transaction_id=${this.urlParams['transaction_id']}`
    );

    // redirect user to callback endpoint
    setTimeout(() => {
      window.location.href = this.callbackEndpoint;
    }, 2000);

    setTimeout(() => {
      this.isRedirectShown = true;
    }, 4000);
  }

  // onReturnToStore() {
  //     window.location.href = this.utilsService.modifyUrl(
  //         this.charge['callback_endpoint'],
  //         `payment_method=CARD&payment_status=${this.urlParams['payment_status']}`
  //     );
  // }
}
